// core
import {
  Component, OnInit, Input, Inject
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

// services
import { RaptorStepService } from '../../services/raptor-step.service';
import { RaptorStepDataService } from '../../services/raptor-step-data.service';
import { RaptorPaymentService } from '../../services/raptor-payment.service';

@Component({
  selector: 'open-raptor-stripe-form',
  templateUrl: './raptor-stripe-form.component.html',
  styleUrls: ['./raptor-stripe-form.component.scss']
})
export class RaptorStripeFormComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() question!: any;
  @Input() option!: any;

  raptorPaymentSubscription!: Subscription;
  serverErrors: any = {};
  test = false;
  terms: any;
  productLabel: any = 'Car';
  quoteProduct: any;
  stripe: any = {};
  loading: boolean = false;
  error: boolean = false;

  constructor(
    public raptorStepService: RaptorStepService,
    public raptorPaymentService: RaptorPaymentService,
    private raptorStepDataService: RaptorStepDataService,
    private partnerBrandService: PartnerBrandService,
    @Inject('environment') public environment: any
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.raptorPaymentService.loadStripe(this.option, () => {
      this.setupStripe();
      this.loading = false;
    });

    // Reinitialise Stripe if payment details have changed.
    this.raptorPaymentSubscription = this.raptorPaymentService.paymentDetails$
      .subscribe((update: boolean) => {
        if (update) {
          this.setupStripe();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.raptorPaymentSubscription) {
      this.raptorPaymentSubscription.unsubscribe();
    }
  }

  setupStripe() {
    // If user is staff, use agent configuration, else use customer configuration
    const formData = this.raptorStepDataService.get();
    
    // Note: 'amount' is mandatory for payment Element creation.
    // But this is not used for creation of payment Intent. BE gets it by it's own logic
    const elementOptions: any = {
      mode: 'payment',
      allowedCardBrands: ['visa', 'mastercard'],
      amount: this.raptorPaymentService.payableFirstInCents,
      paymentMethodCreation: 'manual',
      setupFutureUsage: 'off_session',
      appearance: { theme: 'stripe' },
      currency: this.question?.settings?.locale?.currency.toLowerCase()
    };

    if (formData.settings.update_payment_details) {
      elementOptions.mode = 'setup';
      delete elementOptions.amount;
    }

    if (
      this.partnerBrandService.data &&
      this.partnerBrandService.data.brand
    ) {
      elementOptions.currency = this.partnerBrandService.data.product?.country?.currency.toLowerCase() ||
        this.question?.settings?.locale?.currency.toLowerCase();
      const bodyFontFamily = '"Open Sans", sans-serif';
      elementOptions.appearance.variables = {
        colorPrimary: '#2F3336',
        colorDanger: '#B70000',
        fontFamily: bodyFontFamily,
        fontSmooth: 'always',
        fontSizeBase: '16px',
        spacingUnit: '5px',
        borderRadius: '4px'
      };
      elementOptions.appearance.rules = {
        '.Input': {
          borderColor: '#949494',
          backgroundColor: 'transparent',
          boxShadow: 'none'
        },
        '.Input::placeholder': {
          color: '#8D94A5',
          fontWeight: 'normal'
        },
        '.Input:hover': {
          borderColor: '#313131'
        },
        '.Input:focus': {
          borderColor: this.partnerBrandService.data.brand.primaryColour,
          boxShadow: 'none',
          outline: `${this.partnerBrandService.data.brand.primaryColour} 1px solid`
        },
        '.Label': {
          fontWeight: '600',
          fontSize: '16px',
          fontFamily: bodyFontFamily
        },
        '.TermsText': {
          fontSize: '0px'
        }
      };
    }

    if (formData.data?.const_is_staff && this.option?.params?.agent_configuration_id) {
      elementOptions.payment_method_configuration = this.option.params.agent_configuration_id;
    } else if (this.option?.params?.customer_configuration_id && (!formData.data.hasOwnProperty('const_is_staff') || formData.data?.const_is_staff === false)) {
      elementOptions.payment_method_configuration = this.option.params.customer_configuration_id;
    }

    this.stripe.service = this.raptorPaymentService.stripeService;
    this.stripe.elements = this.stripe.service.elements(elementOptions);

    this.stripe.fields = this.raptorPaymentService.stripeFields;

    const createOptions: any = {
      fields: {
        billingDetails: {
          address: { country: 'never' }
        }
      },
      layout: {
        type: 'accordion',
        defaultCollapsed: false,
        radios: true,
        spacedAccordionItems: false
      }
    };

    

    // address: { country: 'never' } is to hide country field in payment Element
    this.stripe.fields.stripePayment = this.stripe.elements.create(
      'payment',
      createOptions
    );
    this.stripe.fields.stripePayment.mount('.stripePayment');

    // Save Stripe element instance in raptorPaymentService
    this.raptorPaymentService.paymentElement = this.stripe.elements;
  }
}
